module.exports = __webpack_public_path__ + "static/media/how-to.a0e9979f.jpg";